import React from 'react';
import './SideNav.css';
import Profile from '../Assets/profile.jpg';
import {useState} from 'react';
import { Link , BrowserRouter as Router} from "react-router-dom";
import { useLocation } from 'react-router-dom';
import {useEffect} from 'react';
export function SideNav(props) {
    const [isSreen, setScreen] = useState(false)
    const {screenSize} = props.screenSize;
    let location = useLocation()
    location.pathname === '/' ? location.pathname = '/home' : location.pathname = location.pathname;
    const [active, setActive] = useState(location.pathname.substring(1,location.pathname.length));
    return (
        <React.Fragment>
        <div id = 'mySidenav' className = 'sidenav'> 
            <div className ='container'>
                <div className = 'profile'>
                    <img src={Profile} alt="Avatar" className="avatar"/>
                </div>
                <hr className = 'side-hr'/>
                <div className = 'links'>
                    <Link to = '/'><span  className = {`${active === 'home'? 'active': null}`} onClick = {()=>setActive('home')}>Home</span></Link>
                    <Link to='/about'><span  className = {`${active === 'about'? 'active': null}`} onClick = {()=>setActive('about')}>About</span></Link>
                    <Link to='/resume'><span  className = {`${active === 'resume'? 'active': null}`} onClick = {()=>setActive('resume')}>Resume</span></Link>
                    {/* <Link to='/blog'><span  className = {`${active === 'blog'? 'active': null}`} onClick = {()=>setActive('blog')}>Blogs</span></Link> */}
                    {/* <Link to='/shop'><span  className = {`${active === 'shop'? 'active': null}`} onClick = {()=>setActive('shop')}>Shop</span></Link> */}
                    <Link to='/contact'><span  className = {`${active === 'contact'? 'active': null}`} onClick = {()=>setActive('contact')}>Contact</span></Link>
                </div>
            </div>
        </div>
    </React.Fragment>
    )
}